import CreateWizardCommon from "@/components/common/CreateWizard";
import ClientFormCommon from "@/components/common/form/ClientForm";
import VehicleFormCommon from "@/components/common/form/VehicleForm";
import {
  BaseSelect,
  BaseTextArea,
  DateAndTime,
} from "@/components/input/CustomInputs";
import DataAutofillSelect from "@/components/input/DataAutofillSelect";
import MultiSelect from "@/components/input/MultiSelect";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { handleFormChange } from "@/utils/formChange";
import InventoryTable from "@/garageManagment/InventoryTable";
import { formInterface } from "@/interface/dataInterface";
import { Calendar1, Car, User } from "lucide-react";
import { FC, FormEvent } from "react";
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import { toast } from "sonner";

const ReservationForm: FC<formInterface> = ({
  mode,
  formProp,
  setFormProp,
  otherData,
  setOtherData,
  submitForm,
}) => {
  const { name, email, phone } = formProp;
  const { make, model, vin, license_plate, year } = formProp;

  const confirmForm = () => {
    if (!formProp.branch_id) {
      toast("Please select a branch");
      return;
    } else if (!formProp.date) {
      toast("Please select a date");
      return;
    } else if (!formProp.technician_id) {
      toast("Please select a technician");
      return;
    }

    submitForm ? submitForm() : () => {};
  };

  return (
    <CreateWizardCommon
      title="reservation"
      buttonTitle="Place new reservation"
      confirmForm={confirmForm}
      isEdit={mode === "edit" ? true : false}
    >
      <FormWizard.TabContent title="Client details" icon={<User />}>
        <div className="block">
          <div className="my-3 flex flex-col sm:flex-row items-center justify-between">
            <Label>Existing client? Import</Label>
            <DataAutofillSelect
              formProp={{ name, email, phone }}
              setFormProp={setFormProp}
              resource="auto-service/clients"
              prop="email"
            />
          </div>
          <form className="reservation-form-step">
            <ClientFormCommon
              formProp={{ name, email, phone }}
              setFormProp={setFormProp}
            />
          </form>
        </div>
      </FormWizard.TabContent>
      <FormWizard.TabContent title="Vehicle Info" icon={<Car />}>
        <div className="mt-5">
          <div className="my-3 flex items-center justify-between">
            <Label>Existing vehicle? Import</Label>
            <DataAutofillSelect
              formProp={{ make, model, license_plate, vin, year }}
              setFormProp={setFormProp}
              resource="auto-service/vehicles"
              prop="license_plate"
            />
          </div>
          <form className="reservation-form-step">
            <VehicleFormCommon
              formProp={{ make, model, license_plate, vin, year }}
              setFormProp={setFormProp}
            />
          </form>
        </div>
      </FormWizard.TabContent>
      <FormWizard.TabContent title="Last step" icon={<Calendar1 />}>
        <form className="reservation-form-step">
          <div className="grid sm:grid-cols-2 gap-5">
            <BaseSelect
              id="branch_id"
              value={formProp.branch_id}
              resource="branches"
              dataProp="name"
              setValue={setFormProp}
              label="Branch"
            />
            <BaseSelect
              id="technician_id"
              value={formProp.technician_id}
              resource="users"
              dataProp="email"
              setValue={setFormProp}
              label="Technician"
            />
            <DateAndTime formProp={formProp} setFormProp={setFormProp} />
            <div className="w-full grid gap-1">
              <Label htmlFor="service" className="text-right">
                Parts *
              </Label>
              <MultiSelect
                resource="auto-service-inventory"
                selected={otherData || []}
                setSelected={setOtherData || (() => {})}
                dataProp="name"
                objectProps={["name", "price", "unit"]}
              />
            </div>
            {mode == "edit" && (
              <div className="grid gap-1">
                <Label htmlFor="status" className="text-right">
                  Status *
                </Label>
                <Input
                  id="status"
                  name="status"
                  type="text"
                  value={formProp.status}
                  onChange={(e: FormEvent<HTMLInputElement>) =>
                    handleFormChange(e, setFormProp)
                  }
                  placeholder="Status"
                  required
                />
              </div>
            )}
            <div className="sm:col-span-2 w-full">
              <BaseTextArea
                id="notes"
                label="Notes"
                value={formProp.notes}
                setProp={setFormProp}
              />
            </div>
          </div>
        </form>
        <div className="w-full">
          <div className="grid place-items-center gap-y-3 overflow-y-auto">
            <InventoryTable
              data={otherData || []}
              setData={setOtherData || (() => {})}
            />
          </div>
        </div>
      </FormWizard.TabContent>
    </CreateWizardCommon>
  );
};

export default ReservationForm;
